import { Router } from "@views/routes/Router";

function App() {
  return <Router />;
}
export default App;
